import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { SocketHealthBucket } from "@/types/ApiResponses/Monitor";

export interface GetSocketHealthParams {
  hours: number;
}

export const getSocketHealth = async (
  props: QueryProps<GetSocketHealthParams>
): Promise<SocketHealthBucket[]> => {
  const res = await api.client.get("/monitor/socket-health", {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
